export const youtubeEmbedUrl = value => {
  try {
    const url = new URL(value);
    if (!['http:', 'https:'].includes(url.protocol)) return null;
    const youtube = /(^|\.)youtube\.com$/i.test(url.hostname);
    const short = url.hostname.toLowerCase() === 'youtu.be';
    if (!youtube && !short) return null;
    const parts = url.pathname.split('/').filter(Boolean);
    const id = short ? parts[0] : url.pathname === '/watch' ? url.searchParams.get('v')
      : ['embed', 'shorts', 'live'].includes(parts[0]) ? parts[1] : null;
    if (!/^[\w-]{11}$/.test(id || '')) return null;
    const embed = new URL('https://www.youtube-nocookie.com/embed/' + id);
    const time = url.searchParams.get('t') || url.searchParams.get('start') || '';
    const duration = time.match(/^(?:(\d+)h)?(?:(\d+)m)?(?:(\d+)s)?$/);
    const seconds = /^\d+$/.test(time) ? Number(time) : duration
      ? Number(duration[1] || 0) * 3600 + Number(duration[2] || 0) * 60 + Number(duration[3] || 0) : 0;
    if (seconds > 0) embed.searchParams.set('start', seconds);
    return embed.toString();
  } catch { return null; }
};
